import { Moon, Sun } from "lucide-react";
import type { JSX } from "react";
import { Button } from "@mailflare/ui";

import { prefersDarkScheme, resolveTheme, useThemeStore } from "@/stores/theme-store";

export function ThemeToggle(): JSX.Element {
  const preference = useThemeStore((state) => state.preference);
  const toggle = useThemeStore((state) => state.toggle);
  const isDark = resolveTheme(preference, prefersDarkScheme()) === "dark";

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      data-testid="theme-toggle"
    >
      {isDark ? <Sun aria-hidden className="size-4" /> : <Moon aria-hidden className="size-4" />}
    </Button>
  );
}
